import type { PriceBreakdown, ValidationResult } from '@cowell/shared';
import { calculatePrice, validateConfig } from '@cowell/shared';
import { useMemo } from 'react';

import { useConfigStore } from './store.js';

export function useConfig() {
  return useConfigStore((s) => s.config);
}

export function usePrice(): PriceBreakdown {
  const config = useConfig();
  return useMemo(() => calculatePrice(config), [config]);
}

export function useValidation(): ValidationResult {
  const config = useConfig();
  return useMemo(() => validateConfig(config), [config]);
}
